import { DragEvent, ReactNode } from 'react';
import classNames from 'classnames';
import colors from 'constants/colors';
import Icon, { IconNames } from 'components/Icon';
import { FilterHeaderInfo } from './HeaderInfo';
import { RecExpandedFilterRow } from './DragNDropRecExpanded';

type FilterRowProps = {
  row: RecExpandedFilterRow;
  isMobile: boolean;
  isDragging: boolean;
  disableDrag: boolean;
  onDragStart: (id: string) => void;
  onDragOver: (event: DragEvent, id: string) => void;
  onDragEnd: () => void;
  onEdit?: (id: string) => void;
  switchCell?: ReactNode;
};

export const FilterRow = ({
  row,
  isMobile,
  isDragging,
  disableDrag,
  onDragStart,
  onDragOver,
  onDragEnd,
  onEdit,
  switchCell,
}: FilterRowProps) => (
  <tr
    draggable={!disableDrag}
    onDragStart={disableDrag ? undefined : () => onDragStart(row.value)}
    onDragOver={disableDrag ? undefined : event => onDragOver(event, row.value)}
    onDragEnd={disableDrag ? undefined : onDragEnd}
    className={classNames('filter-row', { 'row-draggable': !disableDrag, dragging: isDragging })}
  >
    <td className={classNames('rec-header-info rec', { mobile: isMobile, active: row.isActive })}>
      <FilterHeaderInfo position={row.position} label={row.label} description={row.description} />
      <div className="flex-wrap-nowrap align-center">
        {onEdit && (
          <button
            type="button"
            className="oath-bodysmall link-text show-hide-text"
            aria-label={`Edit ${row.label}`}
            onClick={() => onEdit(row.value)}
          >
            Edit
          </button>
        )}
        {!disableDrag && <Icon name={IconNames.Menu} color={colors.gray} size={16} />}
      </div>
    </td>
    <td className="delete-td rec payment-switch-td">{switchCell}</td>
  </tr>
);
